import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-1',
  templateUrl: './cards-1.component.html'
})
export class Cards1Component {

}
